import * as React from 'react';
export var SocialIconG = function SocialIconG() {
  return /*#__PURE__*/React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 16 16",
    width: "16",
    height: "16"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    fillRule: "evenodd",
    d: "M7.987 6.515v2.97l4.047-.003c-.633 1.925-1.62 2.975-4.047 2.975-2.456 0-4.373-1.996-4.373-4.457 0-2.46 1.917-4.456 4.373-4.456 1.299 0 2.138.458 2.907 1.095.617-.617.564-.705 2.131-2.187A7.452 7.452 0 0 0 7.985.5C3.853.5.5 3.858.5 8c0 4.142 3.352 7.5 7.487 7.5 6.18 0 7.691-5.392 7.19-8.985h-7.19z"
  }));
};